"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PayProtocolFeeError = exports.ExchangeInvalidContextError = exports.IncompleteFillError = exports.TransactionInvalidContextError = exports.TransactionGasPriceError = exports.TransactionExecutionError = exports.TransactionError = exports.NegativeSpreadError = exports.AssetProxyTransferError = exports.AssetProxyDispatchError = exports.AssetProxyExistsError = exports.OrderEpochError = exports.FillError = exports.OrderStatusError = exports.EIP1271SignatureError = exports.SignatureWalletError = exports.SignatureValidatorNotApprovedError = exports.SignatureError = exports.BatchMatchOrdersError = exports.IncompleteFillErrorCode = exports.TransactionErrorCode = exports.AssetProxyDispatchErrorCode = exports.SignatureErrorCode = exports.FillErrorCode = exports.ExchangeContextErrorCodes = exports.BatchMatchOrdersErrorCodes = void 0;

var revert_error_1 = require("../../revert_error"); // tslint:disable:max-classes-per-file


var BatchMatchOrdersErrorCodes;

(function (BatchMatchOrdersErrorCodes) {
  BatchMatchOrdersErrorCodes[BatchMatchOrdersErrorCodes["ZeroLeftOrders"] = 0] = "ZeroLeftOrders";
  BatchMatchOrdersErrorCodes[BatchMatchOrdersErrorCodes["ZeroRightOrders"] = 1] = "ZeroRightOrders";
  BatchMatchOrdersErrorCodes[BatchMatchOrdersErrorCodes["InvalidLengthLeftSignatures"] = 2] = "InvalidLengthLeftSignatures";
  BatchMatchOrdersErrorCodes[BatchMatchOrdersErrorCodes["InvalidLengthRightSignatures"] = 3] = "InvalidLengthRightSignatures";
})(BatchMatchOrdersErrorCodes = exports.BatchMatchOrdersErrorCodes || (exports.BatchMatchOrdersErrorCodes = {}));

var ExchangeContextErrorCodes;

(function (ExchangeContextErrorCodes) {
  ExchangeContextErrorCodes[ExchangeContextErrorCodes["InvalidMaker"] = 0] = "InvalidMaker";
  ExchangeContextErrorCodes[ExchangeContextErrorCodes["InvalidTaker"] = 1] = "InvalidTaker";
  ExchangeContextErrorCodes[ExchangeContextErrorCodes["InvalidSender"] = 2] = "InvalidSender";
})(ExchangeContextErrorCodes = exports.ExchangeContextErrorCodes || (exports.ExchangeContextErrorCodes = {}));

var FillErrorCode;

(function (FillErrorCode) {
  FillErrorCode[FillErrorCode["InvalidTakerAmount"] = 0] = "InvalidTakerAmount";
  FillErrorCode[FillErrorCode["TakerOverpay"] = 1] = "TakerOverpay";
  FillErrorCode[FillErrorCode["Overfill"] = 2] = "Overfill";
  FillErrorCode[FillErrorCode["InvalidFillPrice"] = 3] = "InvalidFillPrice";
})(FillErrorCode = exports.FillErrorCode || (exports.FillErrorCode = {}));

var SignatureErrorCode;

(function (SignatureErrorCode) {
  SignatureErrorCode[SignatureErrorCode["BadOrderSignature"] = 0] = "BadOrderSignature";
  SignatureErrorCode[SignatureErrorCode["BadTransactionSignature"] = 1] = "BadTransactionSignature";
  SignatureErrorCode[SignatureErrorCode["InvalidLength"] = 2] = "InvalidLength";
  SignatureErrorCode[SignatureErrorCode["Unsupported"] = 3] = "Unsupported";
  SignatureErrorCode[SignatureErrorCode["Illegal"] = 4] = "Illegal";
  SignatureErrorCode[SignatureErrorCode["InappropriateSignatureType"] = 5] = "InappropriateSignatureType";
  SignatureErrorCode[SignatureErrorCode["InvalidSigner"] = 6] = "InvalidSigner";
})(SignatureErrorCode = exports.SignatureErrorCode || (exports.SignatureErrorCode = {}));

var AssetProxyDispatchErrorCode;

(function (AssetProxyDispatchErrorCode) {
  AssetProxyDispatchErrorCode[AssetProxyDispatchErrorCode["InvalidAssetDataLength"] = 0] = "InvalidAssetDataLength";
  AssetProxyDispatchErrorCode[AssetProxyDispatchErrorCode["UnknownAssetProxy"] = 1] = "UnknownAssetProxy";
})(AssetProxyDispatchErrorCode = exports.AssetProxyDispatchErrorCode || (exports.AssetProxyDispatchErrorCode = {}));

var TransactionErrorCode;

(function (TransactionErrorCode) {
  TransactionErrorCode[TransactionErrorCode["AlreadyExecuted"] = 0] = "AlreadyExecuted";
  TransactionErrorCode[TransactionErrorCode["Expired"] = 1] = "Expired";
})(TransactionErrorCode = exports.TransactionErrorCode || (exports.TransactionErrorCode = {}));

var IncompleteFillErrorCode;

(function (IncompleteFillErrorCode) {
  IncompleteFillErrorCode[IncompleteFillErrorCode["IncompleteMarketBuyOrders"] = 0] = "IncompleteMarketBuyOrders";
  IncompleteFillErrorCode[IncompleteFillErrorCode["IncompleteMarketSellOrders"] = 1] = "IncompleteMarketSellOrders";
  IncompleteFillErrorCode[IncompleteFillErrorCode["IncompleteFillOrder"] = 2] = "IncompleteFillOrder";
})(IncompleteFillErrorCode = exports.IncompleteFillErrorCode || (exports.IncompleteFillErrorCode = {}));

var BatchMatchOrdersError = /*#__PURE__*/function (_revert_error_1$Rever) {
  _inherits(BatchMatchOrdersError, _revert_error_1$Rever);

  var _super = _createSuper(BatchMatchOrdersError);

  function BatchMatchOrdersError(error) {
    _classCallCheck(this, BatchMatchOrdersError);

    return _super.call(this, 'BatchMatchOrdersError', 'BatchMatchOrdersError(uint8 error)', {
      error: error
    });
  }

  return BatchMatchOrdersError;
}(revert_error_1.RevertError);

exports.BatchMatchOrdersError = BatchMatchOrdersError;

var SignatureError = /*#__PURE__*/function (_revert_error_1$Rever2) {
  _inherits(SignatureError, _revert_error_1$Rever2);

  var _super2 = _createSuper(SignatureError);

  function SignatureError(error, hash, signer, signature) {
    _classCallCheck(this, SignatureError);

    return _super2.call(this, 'SignatureError', 'SignatureError(uint8 error, bytes32 hash, address signer, bytes signature)', {
      error: error,
      hash: hash,
      signer: signer,
      signature: signature
    });
  }

  return SignatureError;
}(revert_error_1.RevertError);

exports.SignatureError = SignatureError;

var SignatureValidatorNotApprovedError = /*#__PURE__*/function (_revert_error_1$Rever3) {
  _inherits(SignatureValidatorNotApprovedError, _revert_error_1$Rever3);

  var _super3 = _createSuper(SignatureValidatorNotApprovedError);

  function SignatureValidatorNotApprovedError(signer, validator) {
    _classCallCheck(this, SignatureValidatorNotApprovedError);

    return _super3.call(this, 'SignatureValidatorNotApprovedError', 'SignatureValidatorNotApprovedError(address signer, address validator)', {
      signer: signer,
      validator: validator
    });
  }

  return SignatureValidatorNotApprovedError;
}(revert_error_1.RevertError);

exports.SignatureValidatorNotApprovedError = SignatureValidatorNotApprovedError;

var SignatureWalletError = /*#__PURE__*/function (_revert_error_1$Rever4) {
  _inherits(SignatureWalletError, _revert_error_1$Rever4);

  var _super4 = _createSuper(SignatureWalletError);

  function SignatureWalletError(hash, wallet, signature, errorData) {
    _classCallCheck(this, SignatureWalletError);

    return _super4.call(this, 'SignatureWalletError', 'SignatureWalletError(bytes32 hash, address wallet, bytes signature, bytes errorData)', {
      hash: hash,
      wallet: wallet,
      signature: signature,
      errorData: errorData
    });
  }

  return SignatureWalletError;
}(revert_error_1.RevertError);

exports.SignatureWalletError = SignatureWalletError;

var EIP1271SignatureError = /*#__PURE__*/function (_revert_error_1$Rever5) {
  _inherits(EIP1271SignatureError, _revert_error_1$Rever5);

  var _super5 = _createSuper(EIP1271SignatureError);

  function EIP1271SignatureError(verifyingContract, data, signature, errorData) {
    _classCallCheck(this, EIP1271SignatureError);

    return _super5.call(this, 'EIP1271SignatureError', 'EIP1271SignatureError(address verifyingContract, bytes data, bytes signature, bytes errorData)', {
      verifyingContract: verifyingContract,
      data: data,
      signature: signature,
      errorData: errorData
    });
  }

  return EIP1271SignatureError;
}(revert_error_1.RevertError);

exports.EIP1271SignatureError = EIP1271SignatureError;

var OrderStatusError = /*#__PURE__*/function (_revert_error_1$Rever6) {
  _inherits(OrderStatusError, _revert_error_1$Rever6);

  var _super6 = _createSuper(OrderStatusError);

  function OrderStatusError(orderHash, status) {
    _classCallCheck(this, OrderStatusError);

    return _super6.call(this, 'OrderStatusError', 'OrderStatusError(bytes32 orderHash, uint8 status)', {
      orderHash: orderHash,
      status: status
    });
  }

  return OrderStatusError;
}(revert_error_1.RevertError);

exports.OrderStatusError = OrderStatusError;

var FillError = /*#__PURE__*/function (_revert_error_1$Rever7) {
  _inherits(FillError, _revert_error_1$Rever7);

  var _super7 = _createSuper(FillError);

  function FillError(error, orderHash) {
    _classCallCheck(this, FillError);

    return _super7.call(this, 'FillError', 'FillError(uint8 error, bytes32 orderHash)', {
      error: error,
      orderHash: orderHash
    });
  }

  return FillError;
}(revert_error_1.RevertError);

exports.FillError = FillError;

var OrderEpochError = /*#__PURE__*/function (_revert_error_1$Rever8) {
  _inherits(OrderEpochError, _revert_error_1$Rever8);

  var _super8 = _createSuper(OrderEpochError);

  function OrderEpochError(maker, sender, currentEpoch) {
    _classCallCheck(this, OrderEpochError);

    return _super8.call(this, 'OrderEpochError', 'OrderEpochError(address maker, address sender, uint256 currentEpoch)', {
      maker: maker,
      sender: sender,
      currentEpoch: currentEpoch
    });
  }

  return OrderEpochError;
}(revert_error_1.RevertError);

exports.OrderEpochError = OrderEpochError;

var AssetProxyExistsError = /*#__PURE__*/function (_revert_error_1$Rever9) {
  _inherits(AssetProxyExistsError, _revert_error_1$Rever9);

  var _super9 = _createSuper(AssetProxyExistsError);

  function AssetProxyExistsError(assetProxyId, assetProxy) {
    _classCallCheck(this, AssetProxyExistsError);

    return _super9.call(this, 'AssetProxyExistsError', 'AssetProxyExistsError(bytes4 assetProxyId, address assetProxy)', {
      assetProxyId: assetProxyId,
      assetProxy: assetProxy
    });
  }

  return AssetProxyExistsError;
}(revert_error_1.RevertError);

exports.AssetProxyExistsError = AssetProxyExistsError;

var AssetProxyDispatchError = /*#__PURE__*/function (_revert_error_1$Rever10) {
  _inherits(AssetProxyDispatchError, _revert_error_1$Rever10);

  var _super10 = _createSuper(AssetProxyDispatchError);

  function AssetProxyDispatchError(error, orderHash, assetData) {
    _classCallCheck(this, AssetProxyDispatchError);

    return _super10.call(this, 'AssetProxyDispatchError', 'AssetProxyDispatchError(uint8 error, bytes32 orderHash, bytes assetData)', {
      error: error,
      orderHash: orderHash,
      assetData: assetData
    });
  }

  return AssetProxyDispatchError;
}(revert_error_1.RevertError);

exports.AssetProxyDispatchError = AssetProxyDispatchError;

var AssetProxyTransferError = /*#__PURE__*/function (_revert_error_1$Rever11) {
  _inherits(AssetProxyTransferError, _revert_error_1$Rever11);

  var _super11 = _createSuper(AssetProxyTransferError);

  function AssetProxyTransferError(orderHash, assetData, errorData) {
    _classCallCheck(this, AssetProxyTransferError);

    return _super11.call(this, 'AssetProxyTransferError', 'AssetProxyTransferError(bytes32 orderHash, bytes assetData, bytes errorData)', {
      orderHash: orderHash,
      assetData: assetData,
      errorData: errorData
    });
  }

  return AssetProxyTransferError;
}(revert_error_1.RevertError);

exports.AssetProxyTransferError = AssetProxyTransferError;

var NegativeSpreadError = /*#__PURE__*/function (_revert_error_1$Rever12) {
  _inherits(NegativeSpreadError, _revert_error_1$Rever12);

  var _super12 = _createSuper(NegativeSpreadError);

  function NegativeSpreadError(leftOrderHash, rightOrderHash) {
    _classCallCheck(this, NegativeSpreadError);

    return _super12.call(this, 'NegativeSpreadError', 'NegativeSpreadError(bytes32 leftOrderHash, bytes32 rightOrderHash)', {
      leftOrderHash: leftOrderHash,
      rightOrderHash: rightOrderHash
    });
  }

  return NegativeSpreadError;
}(revert_error_1.RevertError);

exports.NegativeSpreadError = NegativeSpreadError;

var TransactionError = /*#__PURE__*/function (_revert_error_1$Rever13) {
  _inherits(TransactionError, _revert_error_1$Rever13);

  var _super13 = _createSuper(TransactionError);

  function TransactionError(error, transactionHash) {
    _classCallCheck(this, TransactionError);

    return _super13.call(this, 'TransactionError', 'TransactionError(uint8 error, bytes32 transactionHash)', {
      error: error,
      transactionHash: transactionHash
    });
  }

  return TransactionError;
}(revert_error_1.RevertError);

exports.TransactionError = TransactionError;

var TransactionExecutionError = /*#__PURE__*/function (_revert_error_1$Rever14) {
  _inherits(TransactionExecutionError, _revert_error_1$Rever14);

  var _super14 = _createSuper(TransactionExecutionError);

  function TransactionExecutionError(transactionHash, errorData) {
    _classCallCheck(this, TransactionExecutionError);

    return _super14.call(this, 'TransactionExecutionError', 'TransactionExecutionError(bytes32 transactionHash, bytes errorData)', {
      transactionHash: transactionHash,
      errorData: errorData
    });
  }

  return TransactionExecutionError;
}(revert_error_1.RevertError);

exports.TransactionExecutionError = TransactionExecutionError;

var TransactionGasPriceError = /*#__PURE__*/function (_revert_error_1$Rever15) {
  _inherits(TransactionGasPriceError, _revert_error_1$Rever15);

  var _super15 = _createSuper(TransactionGasPriceError);

  function TransactionGasPriceError(transactionHash, actualGasPrice, requiredGasPrice) {
    _classCallCheck(this, TransactionGasPriceError);

    return _super15.call(this, 'TransactionGasPriceError', 'TransactionGasPriceError(bytes32 transactionHash, uint256 actualGasPrice, uint256 requiredGasPrice)', {
      transactionHash: transactionHash,
      actualGasPrice: actualGasPrice,
      requiredGasPrice: requiredGasPrice
    });
  }

  return TransactionGasPriceError;
}(revert_error_1.RevertError);

exports.TransactionGasPriceError = TransactionGasPriceError;

var TransactionInvalidContextError = /*#__PURE__*/function (_revert_error_1$Rever16) {
  _inherits(TransactionInvalidContextError, _revert_error_1$Rever16);

  var _super16 = _createSuper(TransactionInvalidContextError);

  function TransactionInvalidContextError(transactionHash, currentContextAddress) {
    _classCallCheck(this, TransactionInvalidContextError);

    return _super16.call(this, 'TransactionInvalidContextError', 'TransactionInvalidContextError(bytes32 transactionHash, address currentContextAddress)', {
      transactionHash: transactionHash,
      currentContextAddress: currentContextAddress
    });
  }

  return TransactionInvalidContextError;
}(revert_error_1.RevertError);

exports.TransactionInvalidContextError = TransactionInvalidContextError;

var IncompleteFillError = /*#__PURE__*/function (_revert_error_1$Rever17) {
  _inherits(IncompleteFillError, _revert_error_1$Rever17);

  var _super17 = _createSuper(IncompleteFillError);

  function IncompleteFillError(error, expectedAssetFillAmount, actualAssetFillAmount) {
    _classCallCheck(this, IncompleteFillError);

    return _super17.call(this, 'IncompleteFillError', 'IncompleteFillError(uint8 error, uint256 expectedAssetFillAmount, uint256 actualAssetFillAmount)', {
      error: error,
      expectedAssetFillAmount: expectedAssetFillAmount,
      actualAssetFillAmount: actualAssetFillAmount
    });
  }

  return IncompleteFillError;
}(revert_error_1.RevertError);

exports.IncompleteFillError = IncompleteFillError;

var ExchangeInvalidContextError = /*#__PURE__*/function (_revert_error_1$Rever18) {
  _inherits(ExchangeInvalidContextError, _revert_error_1$Rever18);

  var _super18 = _createSuper(ExchangeInvalidContextError);

  function ExchangeInvalidContextError(error, orderHash, contextAddress) {
    _classCallCheck(this, ExchangeInvalidContextError);

    return _super18.call(this, 'ExchangeInvalidContextError', 'ExchangeInvalidContextError(uint8 error, bytes32 orderHash, address contextAddress)', {
      error: error,
      orderHash: orderHash,
      contextAddress: contextAddress
    });
  }

  return ExchangeInvalidContextError;
}(revert_error_1.RevertError);

exports.ExchangeInvalidContextError = ExchangeInvalidContextError;

var PayProtocolFeeError = /*#__PURE__*/function (_revert_error_1$Rever19) {
  _inherits(PayProtocolFeeError, _revert_error_1$Rever19);

  var _super19 = _createSuper(PayProtocolFeeError);

  function PayProtocolFeeError(orderHash, protocolFee, makerAddress, takerAddress, errorData) {
    _classCallCheck(this, PayProtocolFeeError);

    return _super19.call(this, 'PayProtocolFeeError', 'PayProtocolFeeError(bytes32 orderHash, uint256 protocolFee, address makerAddress, address takerAddress, bytes errorData)', {
      orderHash: orderHash,
      protocolFee: protocolFee,
      makerAddress: makerAddress,
      takerAddress: takerAddress,
      errorData: errorData
    });
  }

  return PayProtocolFeeError;
}(revert_error_1.RevertError);

exports.PayProtocolFeeError = PayProtocolFeeError;
var types = [AssetProxyExistsError, AssetProxyDispatchError, AssetProxyTransferError, BatchMatchOrdersError, EIP1271SignatureError, ExchangeInvalidContextError, FillError, IncompleteFillError, NegativeSpreadError, OrderEpochError, OrderStatusError, PayProtocolFeeError, SignatureError, SignatureValidatorNotApprovedError, SignatureWalletError, TransactionError, TransactionExecutionError, TransactionGasPriceError, TransactionInvalidContextError]; // Register the types we've defined.

for (var _i = 0, _types = types; _i < _types.length; _i++) {
  var type = _types[_i];
  revert_error_1.RevertError.registerType(type);
}